import {
    BrowseCourseCarouselConfiguration,
    CAROUSEL_CONFIGURATIONS,
} from '@udemy-v2/react-browse-course';
import type {BrowseCourseCardProps} from '@udemy-v2/react-browse-course';

/** Desktop carousel layout shared across CLP recommendation surfaces. */
export const DESKTOP_BROWSE_COURSE_CAROUSEL_CONFIGURATION: BrowseCourseCarouselConfiguration =
    {
        ...CAROUSEL_CONFIGURATIONS.CARDS_FULL_WIDTH,
        carouselProps: {
            allowScroll: true,
        },
    };

export const DESKTOP_BROWSE_COURSE_CARD_OPTIONS: BrowseCourseCardProps['options'] = {
    openInNewTab: true,
};
